jQuery(window).on( 'load', function() {
    
    // jQuery('<li class="dg_footer_item_6"><a id="salesforceFormSelect" href="javascript:void(0)">Contact Us</a></li>').insertAfter('.dg_footer_item_5');

});

jQuery(document).ready(function($) {


// simple submit counter for MOM info submissions

jQuery('input#first-submit').on( 'click', function(e) {



    jQuery.ajax({
        type: "get",
        url: ajaxurl, // or example_ajax_obj.ajaxurl if using on frontend
        data: {
            'action': 'crown_count_submission',
            
        },
        success:function(data) {
            // This outputs the result of the ajax request
            console.log('Success: '+data);
        },
        error: function(errorThrown){

            console.log('Error: '+errorThrown);
        }
    });  

});



    //This changes the wordmark scroll rate to create a parallaxish effect

    $('.wordmark').css({'top': "0"});

    $(window).scroll(function () { 
    
        $('.wordmark').css({
            'top' : -($(this).scrollTop()/2.5)+"px" // increase # to make even slower
        });

       
    });

    //This fades the hero bottle as it scrolls out of view
	
	// if ( $('body.home').length > 0 ) {

    // 	var header = $('.hero img');
    // 	var range = 200;

    // 	$(window).on('scroll', function () {
      
    //     	var scrollTop = $(this).scrollTop();
    //     	var offset = header.offset().top;
    //     	var height = header.outerHeight();
    //     	offset = offset + height / 2;
    //     	var calc = 1 - (scrollTop - offset + range) / range;
      
    //     	header.css({ 'opacity': calc });
      
    //     	if ( calc > '1' ) {
    //       	  header.css({ 'opacity': 1 });
    //     	} else if ( calc < '0' ) {
    //       	  header.css({ 'opacity': 0 });
    //     	}
      
    // 	});
	// }

    // TEMPORARY: solution for duplicate recipes where JSON is failing
    
    $('a[href="/whisky-cocktails/crown-royal-hard-cherry-cola/"]').parent('div').hide()
    $('a[href="/whisky-cocktails/crown-royal-hard-ginger-ale/"]').parent('div').hide()

    // dynamic square
    function dynamicSquare() {
        $('.dynamic-square').each(function() {
            $(this).height($(this).width());
        })
    }
    // mobile nav positioning
    function mobileNavWrapperTop() {
        $('.mobile-menu-wrapper .mobile-nav').css('padding-top', $('#masthead').height() + 65);
    }
    // one third box
    function oneThirdBox() {
        $('.box-one-third').each(function() {
            $(this).height($('.box-one-third').first().width());
        })
    }
    oneThirdBox();
    dynamicSquare();
    // toggle nav active state
    function slideOpen() {
        var subMenuWidth = $(this).children('ul').width() / 2;
        $(this).animate({
            left: -subMenuWidth
        });
    }

    function slideClose() {
        var subMenuWidth = $(this).children('ul').width() / 2;
        $(this).animate({
            left: subMenuWidth
        });
    }
    // $('.toggle-menu > li').click(function(e) {
    //     $('.toggle-menu .toggle-menu-items').scrollLeft(0);
    //     $('.toggle-menu > li').not(this).removeClass('active');
    //     $(this).toggleClass('active');
    //     if ($(window).width() > 1200) {
    //         var subMenuWidthHalf = $(this).children('ul').width() / 2;
    //         $('.toggle-menu > li:not(.active)').animate({
    //             left: 0
    //         });
    //         $('.toggle-menu > li.active').animate({
    //             left: -subMenuWidthHalf
    //         });
    //     }
    // })

    $('.toggle-menu > li .toggle-menu-items').click(function(e) {
            e.stopPropagation();
        })
        // ul select functionality
    $('ul.select').click(function() {
            //$('ul.select').removeClass('active');
            $(this).toggleClass('active');
        })
    $('.variety-select').click(function() {
            //$('ul.select').removeClass('active');
            $('.occasion-select').removeClass('active');
        })    
    $('.occasion-select').click(function() {
            //$('ul.select').removeClass('active');
            $('.variety-select').removeClass('active');
        })

        // mege menu
    $('.mm-parent > a').click(function(e) {
        e.preventDefault();
    })
    $('.mm-parent').click(function() {
        $(this).toggleClass('active');
        $('.mega-menu-wrapper').toggleClass('active');
        $('body, html').toggleClass('no-overflow').toggleClass('mega-menu-open');
    })
    $('.mm-overlay').click(function() {
            $('.mega-menu-wrapper, .mm-parent').toggleClass('active');
            $('body, html').toggleClass('no-overflow').toggleClass('mega-menu-open');
        })
        // clear default form inpue values on focus
    // $('input[type="text"], input[type="search"], input[type="email"], textarea').on('focus', function(e) {
    //         $(this).attr('value', '');
    //     })
        // init match height
    $('.mh-item').matchHeight();
    // If YouTube video present, set aspect ratio to 16:9
    var iframe = document.querySelector('iframe');
    if (document.body.classList.contains('single-post') && iframe !== null && iframe.src.includes('youtube.com')) {
        iframe.parentElement.style = '--aspect-ratio: 16/9;';
    }
    // mobile nav toggle
    $('#mobile-nav-toggle').click(function(event) {
        $('.mobile-menu-wrapper, #mobile-nav-toggle > li').toggleClass('active');
        $('body, html').toggleClass('no-overflow')
        mobileNavWrapperTop();
        if ($('body').hasClass('no-overflow')) {
            document.ontouchmove = function(event) {
                event.preventDefault();
            }
        } else {
            document.ontouchmove = function(event) {
                return true
            }
        }
    })
    $(window).load(function() {
        dynamicSquare();;
        mobileNavWrapperTop();
        oneThirdBox();
    })
    $(window).resize(function() {
        dynamicSquare();
        mobileNavWrapperTop();
        oneThirdBox();
        if ($(window).width() > 1200) {
            // remove active class and no overflow class from mobile menu elements if window is greater than 1200px
            $('.mobile-menu-wrapper, #mobile-nav-toggle > li').removeClass('active');
            $('body, html').removeClass('no-overflow');
        } else {
            $('.mm-parent, .mega-menu-wrapper').removeClass('active');
        }
    });
    /*$(window).bind('scroll', function() {
        if ($(window).scrollTop() > 100) {
            $('#sticky-nav').addClass('active');
        } else {
            $('#sticky-nav').removeClass('active');
        }
    });*/

    $('.toggle-menu li:first-child').click( function() {
        $(this).toggleClass('active');
        $(this).siblings('.toggle-sub-menu').toggleClass('active');
    });


   
    // Controls for Terms and Conditions modal
    jQuery('.terms-trigger').on( 'click', function() {

        jQuery('.terms-modal').show();
    
    });  
     // Controls for Rules modal
    jQuery('.rules-trigger').on( 'click', function() {

        jQuery('.rules-modal').show();
    
    });
    
    jQuery('.terms-modal #close').on( 'click',  function() {
        
        console.log('close me');
        jQuery('.terms-modal').hide();
   
    
    });
    jQuery('.rules-modal #close').on( 'click',  function() {
        
        console.log('close me');
        jQuery('.rules-modal').hide();
   
    
    });
    
    // Add Date Picker to CYM forms
    // jQuery(document).ready(function() {
    //     $("#mom-datepicker").datepicker(
    //         {
    //             minDate: new Date(1910,1-1,1), maxDate: '-21Y',
    //             dateFormat: 'mm/dd/yy',
    //             defaultDate: new Date(1970,1-1,1),
    //             changeMonth: true,
    //             changeYear: true,
    //             yearRange: '-110:-21'
    //         }
    //     );
    //     $("#cym-datepicker").datepicker(
    //         {
    //             minDate: new Date(1910,1-1,1), maxDate: '-21Y',
    //             dateFormat: 'mm/dd/yy',
    //             defaultDate: new Date(1970,1-1,1),
    //             changeMonth: true,
    //             changeYear: true,
    //             yearRange: '-110:-21'
    //         }
    //     );
    // });
});


//    jQuery('section.hero-slider').unslider(({
//         // autoplay: true,
//         infinite: true,
//         // animation: 'fade',
//         arrows: true,
//         nav: true

//     }));


//     jQuery(window).load( function () {
//         var W = jQuery(window).width();
//         if ( W < 601 ) {

//             if ( jQuery('#bag-slide').hasClass('unslider-active') ) {
//                     jQuery('.unslider-nav').delay(1000).css({'top' : 772 });

//                 }
//                 if ( jQuery('#hero-slide').hasClass('unslider-active') ) {
//                     jQuery('.unslider-nav').delay(1000).css({'top' : 872 });

//                 }
//                 if ( jQuery('#indy-slide').hasClass('unslider-active') ) {
//                     jQuery('.unslider-nav').delay(1000).css({'top' : 1102 });

//                 }

//             }
    
//         jQuery(window).on('resize', function() {

//             var W = jQuery(window).width();
//             var C = jQuery('.pull-right .text-center').width();
//             var Crt = jQuery('.unslider-active .pull-right .text-center').offset();
//             //console.log(W+', '+C+', '+Crt.left);

//             // jQuery(window).load( function() {
//             var Th = jQuery('.unslider-active .pull-right').outerHeight();

//             jQuery('.unslider-arrow').click ( function() {
//                 var Th = jQuery('.unslider-active .pull-right').outerHeight();
//             });
            
//             var offset = (W/2) + (C/2) - 30;
//             // var offset = (W/2) + (C/2) + 35 - 3;
//             var midoffset = (C/2) + Crt.left - 23;
//             if (W < 601) {
//                         var topoffset = Th + 299;

//                         if ( jQuery('#hero-slide').hasClass( "unslider-active") ) {
//                             var topoffset = Th + 329;
//                         }
//                          else if ( jQuery('#indy-slide').hasClass( "unslider-active") ) {
//                             var topoffset = Th + 559;
//                         }

//                     } else {
//                         var topoffset = Th + 399;
//                     }

//             if (W > 1200) {
//                 jQuery('.unslider-nav ol').css({'left' : offset});
//             }

//             else if (W <= 1200 && W > 991) {
//                 jQuery('.unslider-nav ol').css({'left' : midoffset});
//             }

//             else if (W <= 991) {
//                 jQuery('.unslider-nav ol').css({'left' : '0'});
//                 jQuery('.unslider-nav').css({'top' : topoffset });
//                 if ( jQuery('#bag-slide').hasClass('unslider-active') ) {
//                     jQuery('.unslider-nav').delay(1000).css({'top' : 772 });
//                 }
//                  if ( jQuery('#sc-slide').hasClass('unslider-active') ) {
//                     jQuery('.unslider-nav').delay(1000).css({'top' : 779 });
//                 }
//                 jQuery('#bag-slide img').delay(1000).css({'max-width' : '55%', 'margin-top' : '50px' });
                    

//                  jQuery('.unslider-arrow').click ( function() {
//                     var Th = jQuery('.unslider-active .pull-right').outerHeight();
//                     if (W < 601) {
//                         var topoffset = Th + 299;

//                          if ( jQuery('#hero-slide').hasClass( "unslider-active") ) {
//                             var topoffset = Th + 329;
//                         }

//                         else if ( jQuery('#indy-slide').hasClass( "unslider-active") ) {
//                             var topoffset = Th + 559;
//                         } else if ( jQuery('#tm-slide').hasClass( "unslider-active") ) {
//                             var topoffset = Th + 599;
//                         } else if ( jQuery('#bm-slide').hasClass( "unslider-active") ) {
//                             var topoffset = Th + 699;
//                         }
//                     } else {
//                         var topoffset = Th + 399;
//                     }
//                     jQuery('.unslider-nav').delay(1000).css({'top' : topoffset });
//                 });

//                  jQuery('.unslider-nav li').click ( function() {
//                     var Th = jQuery('.unslider-active .pull-right').outerHeight();
//                     if (W < 601) {
//                         var topoffset = Th + 399;

//                          if ( jQuery('#hero-slide').hasClass( "unslider-active") ) {
//                             var topoffset = Th + 329;
//                         }
//                         else if ( jQuery('#bm-slide').hasClass( "unslider-active") ) {
//                             var topoffset = Th + 729;
//                         }
//                         else if ( jQuery('#tm-slide').hasClass( "unslider-active") ) {
//                             var topoffset = Th + 599;
//                         } 
//                         else if ( jQuery('#default-slide').hasClass( "unslider-active") ) {
//                             var topoffset = Th + 349;
//                         } 
//                     } else {
//                         var topoffset = Th + 399;
//                     }
//                     jQuery('.unslider-nav').delay(1000).css({'top' : topoffset });
//                     if ( jQuery('#bag-slide').hasClass( "unslider-active") ) {
//                         jQuery('.unslider-nav').delay(1000).css({'top' : 772 });
//                         jQuery('#bag-slide img').delay(1000).css({'max-width' : '55%', 'margin-top' : '50px' });
//                     }
//                     if ( jQuery('#indy-slide').hasClass( "unslider-active") ) {
//                         jQuery('.unslider-nav').delay(1000).css({'top' : 802 });
                       
//                     }
                     
//                 }); 
//             }


//         }).resize();

//     }); 

// jQuery('#hero-slide .overlay-hack').click( function() {
//     // console.log('clicked me');
//     var url = 'https://apfco.com/secure/W1725/';
//     window.open(url);

// });

jQuery('#indy-slide .overlay-hack').click( function() {
    // console.log('clicked me');
    var url = '/indy-500-wall/';
    window.location = url;

});

// jQuery('#default-slide .overlay-hack').click( function() {
//     // console.log('clicked me');
//     var url = '/canadian-whisky/';
//     window.location = url;

// });

// jQuery('#tm-slide .overlay-hack').click( function() {
//     // console.log('clicked me');
//     var url = '/canadian-whisky/texas-mesquite/';
//     window.location = url;

// });

// jQuery('#bm-slide .overlay-hack').click( function() {
//     // console.log('clicked me');
//     var url = '/canadian-whisky/blenders-mash/';
//     window.location = url;

// });

